import React from "react";
import { Loader2 } from "lucide-react";

const VARIANTS = {
  idle: "bg-primary text-primary-foreground hover:bg-primary/90",
  live: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  connecting: "bg-secondary text-secondary-foreground cursor-wait",
  disabled: "bg-secondary text-muted-foreground opacity-60 cursor-not-allowed",
};

export const BigActionButton = ({ state = "idle", children, onClick, icon: Icon, testId }) => {
  const cls = VARIANTS[state] || VARIANTS.idle;
  const disabled = state === "connecting" || state === "disabled";
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className={`relative flex h-16 w-full items-center justify-center gap-3 rounded-[var(--radius)] text-base font-semibold tracking-wide transition-colors active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:h-[72px] ${cls}`}
      style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}
    >
      {state === "connecting" ? <Loader2 className="h-5 w-5 animate-spin" /> : Icon ? <Icon className="h-5 w-5" /> : null}
      {children}
    </button>
  );
};
